/* ################ AUTH  Routes ######################### */
export const LOGIN = '/login';
export const SIGNUP = '/signup';
export const LOGOUT = '/logout';
export const RESET_PASSWORD = '/reset-password';
export const FORGOT_PASSWORD = '/forgot-password';
export const NEW_PASSWORD = '/reset-password/:id';
export const COMING_SOON = '/coming-soon';
export const MARKET_ONBOARD_COMPANY = '/onboard-marketing-company/:id';

export const DASHBOARD = '/dashboard';
export const USER = '/user';
export const MARKETING_USER = '/marketing-user';

export const SUPER_ADMIN_USER = '/super-admin-user';

/* ################ Products ######################### */
export const PRODUCT_CATALOGUE = '/catalogue';
export const CREATE_PRODUCT = '/product';
export const EDIT_PRODUCT = '/edit-product/:companyId/:id';
export const OFFERINGS = '/offerings';
export const CREATE_OFFERINGS = '/create-offerings';
export const EDIT_OFFERINGS = '/edit-offerings/:companyId/:id';

/* ################ Market Place ######################### */
export const MARKET_PLACE = '/market-place';

/* ################ Samplings ######################### */
export const SAMPLE_ORDERS = '/samplings/sample-orders';

/* ################ Manage Orders ######################### */
export const ORDERS = '/manage-orders/orders';
export const PROCESSING = '/manage-orders/processing';
export const RETURNS = '/manage-orders/returns';

/* #################### Campaigns ######################### */
export const CAMPAIGN = '/campaigns';
export const CREATE_CAMPAIGN = '/create-campaign';
export const CAMPAIGN_DETAILS = '/campaign-details/:companyId/:id';
